<template>
  <embedded-crud-table
    ref="table"
    :entity="entity"
    :entity-store="entityStore"
    :columns="columns"
    :generate-summary="generateSummary"
    :definition="definition"
    :caption="caption"
    :disabled="disabled"
    :allow-actions="true"
    :allow-create="false"
    :allow-delete="false"
    parent-id-filter-field="fabricOrderID"
    :open-in-fullscreen="openInFullscreen"
    :required="required"
    :create-item-from-form-data="createItemFromFormData"
    :create-form-data-from-item="createFormDataFromItem"
    permission-code="FabricOrder"
    :on-table-row-double-click="onTableRowDoubleClick"
    :on-edit="onTableRowDoubleClick"
  />
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import formMixin from './orderlines/form-mixin';

const Labels = {
  FeedbackOK: 'fabricOrder.feedbackOK',
  FeedbackError: 'fabricOrder.feedbackError',
  FeedbackUndefined: 'fabricOrder.feedbackUndefined'
};

export default {
  components: {
    EmbeddedCrudTable
  },
  mixins: [formMixin],
  props: {
    caption: String,
    disabled: {
      default: false,
      type: Boolean
    },
    openInFullscreen: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    columns() {
      return [
        { field: 'orderNumber', label: 'fabricOrder.orderNumber' },
        { field: 'ean', label: 'common.ean' },
        { field: 'articleNumber', label: 'fabric.domainProductCode' },
        { field: 'fabricDescription', label: 'fabric.description' },
        { field: 'positionCode', label: 'stock.positionCode' },
        { field: 'quantityOrderedInMeters', label: 'fabricOrder.orderedQuantity' },
        { field: 'totalQuantityDeliveredInMeters', label: 'fabricOrder.totalDeliveredQuantity' },
        { field: 'quantityDeliveredInMeters', label: 'fabricOrder.deliveredQuantity' },
        { field: 'remarks', label: 'common.remarks' },
        {
          field: 'feedbackSuccessYN',
          label: 'fabricOrder.feedbackSuccessYN',
          width: '120px',
          formatter: this.formatFeedbackSuccessYN,
          filter: {
            type: 'select',
            options: [
              { value: true, label: this.$t(Labels.FeedbackOK) },
              { value: false, label: this.$t(Labels.FeedbackError) }
            ],
            valueField: 'value',
            labelField: 'label'
          }
        }
      ];
    }
  },
  methods: {
    generateSummary(row) {
      return `${row.fabricName}`;
    },
    formatFeedbackSuccessYN(row, column, cellValue) {
      if (cellValue === null) {
        return this.$t(Labels.FeedbackUndefined);
      }
      return cellValue ? this.$t(Labels.FeedbackOK) : this.$t(Labels.FeedbackError);
    },
    onTableRowDoubleClick(row) {
      const { id } = row;
      if (!row.rollsOfFabric) {
        this.$refs.table.showEditInternal(id);
      } else {
        this.$router.push({ name: 'EditFabricRolls', params: { id } });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
